import { Location } from "react-router";

export const
    UpdateLocation: IRoutingUpdateLocationActionCreator = (location) => {
        return {
            type: ACTION_ROUTING_UPDATE_LOCATION,
            location: location
        }
    };



export const
    ACTION_ROUTING_UPDATE_LOCATION = "ACTION_ROUTING_UPDATE_LOCATION";

export interface IRoutingUpdateLocationAction {
    type: "ACTION_ROUTING_UPDATE_LOCATION";
    location: Location;
}

export interface IRoutingUpdateLocationActionCreator {
    (location: Location): IRoutingUpdateLocationAction;
}


export type RoutingAction =
    IRoutingUpdateLocationAction;
